import { Button } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowLeftIcon from '@/assets/icons/ic-arrow-left.svg';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';

export const BackToLectureButton = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));
  const { t } = useTranslation();

  const href = `/lecture/${lectureId}-${lecture.slug}`;

  return (
    <NextLink color="white" href={href} passHref>
      <Button color="white" mb="4" variant="link" colorScheme="black" fontWeight="bold" leftIcon={<ArrowLeftIcon />}>
        {t('lectureEmbed.goToLecture')}
      </Button>
    </NextLink>
  );
};
